
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/statement2",
      function () {
        return require("private-next-pages/statement2.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/statement2"])
      });
    }
  